import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import REQ_URL from '@/consts/req-url';
import { Products, sProducts, sProduct, Product, sProductsToProducts } from '@/api/product';
import { addProductToBasketOpts } from '@/types/basket';
import { modalParams } from '@/types/state.modal';
import autoSelect from '@/api/autoSelect';
import { PagedResponse } from '@/types/response-data';
import { FilterParams } from '@/types/filter';

@Component({
    model: {
        prop: 'isShowDialog',
        event: 'show'
    },
})
export default class ProductQuickAddPanel extends Vue {
    @Prop() isShowDialog = false
    timerId: number | null = null
    timerDelay = 500
    item: sProduct | null = null
    count: string | null = null
    items: Product[] = []
    listWrapper!: HTMLElement
    loading = false
    hideNoData = true
    search: null | string = null
    prevSearch = null
    filterParams: FilterParams = {
        brand: '',
        spec: '',
        search: '',
        analogIds: [],
        exclude: [],
        unsecured: false
    }
    pageInfo = {
        curr: 1,
        of: 1
    }
    get showDialog() {
        return this.isShowDialog
    }
    set showDialog(val) {
        this.$emit('show', val)
    }
    @Watch('search') onSearch(val: string, oldVal: string) {
        this.unbindInfiniteScroll()
        if (val === null) {
            if (this.timerId !== null) clearTimeout(this.timerId)
            return;
        }
        if (this.timerId !== null) clearTimeout(this.timerId)
        this.timerId = setTimeout(() => this.searchRequest(), this.timerDelay)
    }
    itemText(product: sProduct) {
        return product.Артикул + ' - ' + product.Наименование
    }
    itemValue(product: sProduct) {
        return product
    }
    itemAvatar(product: sProduct) {
        return product.Фото
    }
    async searchRequest(nextPage = false) {
       
        if (!this.search) return;
        let page;
        if (nextPage) page = this.pageInfo.curr + 1
        else {
            page = this.pageInfo.curr = this.pageInfo.of = 1
            this.$nextTick(() => this.listWrapper && (this.listWrapper.scrollTop = 0))
        }
        this.hideNoData = true
        this.loading = true
        try {
            this.filterParams.search = this.search
            let data = await this.$fetch<PagedResponse<sProducts>>(REQ_URL.QUICK_SEARCH, {
                method: 'POST',
                body: JSON.stringify({
                    filterParams: this.filterParams,
                    sortBy: "vend_asc",
                    page,
                    perPage: 50,
                    viewMode: "full"
                })
            })
            if (data.body) {
                if (nextPage) this.items.push(...sProductsToProducts(data.body.pageContent))
                else this.items = sProductsToProducts(data.body.pageContent)
                if (!data.body.pageContent.length) this.hideNoData = false
                if (data.body.pageInfo) this.pageInfo = data.body.pageInfo
                else this.pageInfo.curr = this.pageInfo.of = 1
                if (this.pageInfo.curr !== this.pageInfo.of)
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.bindInfiniteScroll()
                        }, 300);
                    })
            } else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            this.hideNoData = false
        }
        this.loading = false
    }
    startEnterCount(ind: number) {
        this.$nextTick(() => {
            (this.$refs[`count${ind}`] as HTMLInputElement).focus()
            this.$nextTick(() => {
                if (this.timerId) clearTimeout(this.timerId)
            })
        })
    }
    addToBasket(ind: number) {
        if (!this.item) return;
        let params: addProductToBasketOpts = {
            quiet: false,
            product: new Product({
                ...this.item,
                quantity: this.count ? +this.count : 0
            })
        }
        this.$store.dispatch('addProductToBasket', params)
        this.item = this.count = null
        this.$nextTick(() => {
            (this.$refs[`autocomplete${ind}`] as HTMLInputElement).focus()
            this.$nextTick(() => {
                this.search = this.prevSearch
                this.$nextTick(() => {
                    (this.$refs[`autocomplete${ind}`] as any).$el.querySelector('input')!.select()
                })
            })
        })
    }
    autoSelect(e: any) {
        this.$nextTick(() => autoSelect(e))
    }
    bindInfiniteScroll() {
        this.listWrapper = ((this.$refs.autocomplete1 ? this.$refs.autocomplete1 : this.$refs.autocomplete2) as Vue).$children
            .filter((children) => children.$options && children.$options.name === 'v-menu')[0].$refs.content as HTMLElement
        this.listWrapper.addEventListener('scroll', this.onListScroll)
    }
    onListScroll(this: ProductQuickAddPanel) {
        if (Math.ceil(this.listWrapper.scrollTop + this.listWrapper.clientHeight) >= this.listWrapper.scrollHeight) {
            this.loadMore();
        }
    }
    unbindInfiniteScroll() {
        if (this.listWrapper) this.listWrapper.removeEventListener('scroll', this.onListScroll)
    }
    loadMore() {
        this.unbindInfiniteScroll()
        if (this.pageInfo.curr === this.pageInfo.of) return;
        this.searchRequest(true)
        this.$nextTick(() => this.listWrapper.scrollTop = this.listWrapper.scrollHeight)
    }
    productBasketCount(vscode: string) {
        let ind = this.$store.getters.basketProducts.findIndex(
          (product: Product) => {
            return product.Артикул === vscode;
          }
        );
        if (ind !== -1)
          return +(this.$store.getters.basketProducts[ind].quantity as string);
        return 0;
      };
    created() {
        this.onListScroll = this.onListScroll.bind(this)
    }
}
